module.exports = __webpack_public_path__ + "github.svg?1bb027109345a90a9eab1e929d8669c2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/github.svg
// module id = 411
// module chunks = 0